<template>
  <div id="operatemonth">
    <!-- <span v-loading.fullscreen.lock="fullscreenLoading"></span> -->
    <CommonLoading ref="commonLoader"></CommonLoading>
    <div class="trader-body">
      <!--<div class="gppzys">
        <span>配资优势</span>
        <img src="../assets/img/cpic.png">
      </div>
      <ul class="gppzys-nr">
        <li>
          <img src="../assets/img/pzfqcg.png">
          <div class="gppzys-r">
            <p>配资发起成功</p>
            <p>5分钟内下户(开盘前下户)</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/cpyltq.png">
          <div class="gppzys-r">
            <p>配资盈利提取</p>
            <p>5分钟到会员账户</p>
          </div>
          <div class="clear"></div>
        </li>
        <li>
          <img src="../assets/img/txmdz.png">
          <div class="gppzys-r">
            <p>提现秒到账</p>
            <p>5分钟内到达银行卡</p>
          </div>
          <div class="clear"></div>
        </li>
        <li style="margin-right:0">
          <img src="../assets/img/mccp.png">
          <div class="gppzys-r">
            <p>100%满仓配资</p>
            <p>单支股票无仓位限制</p>
          </div>
          <div class="clear"></div>
        </li>
        <div class="clear"></div>
      </ul>
      <div class="gppzys">
        <span>股票配资流程</span>
        <img src="../assets/img/cpic.png">
      </div>
      <div class="gppzlc">
        <img src="../assets/img/peiziimg2.jpg">
      </div>-->
      <div class="trader-at">
        <el-card class="box-card" shadow="never">
          <el-row>
            <el-col :span="20">
              <el-form ref="form" label-width="150px" label-position="right">
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatemonth.deposit') }}:</span>
                  <el-input v-model.number="principal" :placeholder="info.explain" type="number"
                    @keyup.native="principalChange" @wheel.prevent style="width: 40%" @blur="isMultiple"></el-input>
                  <p class="infoColor">{{ info.explain }}</p>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatemonth.allocationFunds') }}:</span>

                  <div class="multiple_box" v-for="(item, index) in multiple" :key="index">
                    <div class="multiple" :class="{ capital_ul2_active: cut == index }" @click="setCut(index, item)">
                      <a href="javascript:void(0);">
                        <p class="multiple_detail">{{ item[0] }}{{ $t('operatemonth.times') }}</p>
                        <p class="multiple_rate">{{ $t('opeatemonth.intrestRate') }}{{ item[2] }}%</p>
                        <p class="multiple_money">{{ parseFloat(item[3]).toFixed(2) }}{{$t('operatemonth.yuan')}}</p>
                      </a>
                    </div>
                  </div>

                  <!-- <el-row :gutter="10">
                    <el-col
                      :span="4"
                      v-for="(item,index) in multiple"
                      :key="index">
                      <div class="multiple"     :class="{capital_ul2_active: cut == index}"  @click="setCut(index,item)">
                        <a href="javascript:void(0);">
                          <p class="multiple_detail">
                            {{item[0]}}倍
                          </p>
                          <p class="multiple_rate">月利率{{item[2]}}%</p>
                          <p class="multiple_money">{{item[3]}}元</p>
                        </a>
                      </div>
                    </el-col>
                  </el-row>-->
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operateday.managementFee') }}:</span>
                  <p>
                    <span class="red">{{ fee }}{{$t('operatemonth.yuan')}}/</span>{{$t('operatemonth.month')}}（{{$t('operatehuhui.allocation')}}{{
                      parseFloat(money).toFixed(2)
                    }}
                    X {{$t('opeatemonth.intrestRate')}}{{ pitchMultiple }}%）<span class="infoColor">{{ $t('operatemonth.automaticRenewal') }}</span>
                  </p>
                </el-form-item>
                <el-form-item>
                  <span slot="label" class="assist_title">{{ $t('operatemonth.fundingInfo') }}:</span>
                  <div class="money_info">
                    <table>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatemonth.totalAllocation') }}</span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(allMoney).toFixed(2) }}{{$t('operatemonth.yuan')}}={{ principal }}({{$t('operatevip.deposit')}})+
                            {{ parseFloat(money).toFixed(2) }}{{$t('operatemonth.yuan')}}({{$t('operatehuhui.allocation')}})
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatemonth.lossWarning') }}<el-tooltip class="item" effect="dark"
                              :content="$t('operate.fundBelowWarning')" placement="top-start"><i
                                class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(warning).toFixed(2) }}{{$t('operatemonth.yuan')}}（{{$t('opeatevip.warningLine')}} = {{$t('operatehuhui.allocation')}} + {{$t('operatevip.deposit')}} X
                            {{ info.warning }}）
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <span class="info_title">{{ $t('operatemonth.lossClosing') }}<el-tooltip class="item" effect="dark"
                              :content="$t('operate.fundbelowLiquidation')" placement="top-start"><i
                                class="el-icon-question red"></i></el-tooltip></span>
                        </td>
                        <td>
                          <span>
                            {{ parseFloat(close).toFixed(2) }}{{$t('operatemonth.yuan')}}（{{$t('operatevip.closeLine')}} = {{$t('operatehuhui.allocation')}} + {{$t('operatevip.deposit')}} X
                            {{ info.close }}）
                          </span>
                        </td>
                      </tr>
                    </table>
                  </div>
                </el-form-item>
                <el-form-item>
                  <p>
                    <input type="checkbox" class="check" v-model="agree" style="padding: 2px;border: 1px solid var(--baseColor);height: 20px;width: 20px;"/>
                    <span>{{ $t('operatemonth.agree') }}</span>
                    <router-link to="/operate/protocol">{{ $t('operatemonth.agreement') }}</router-link>
                  </p>
                  <p>
                    <span class="info_title" style="color: #ca3c4d;">{{$t('operateweek.realPayment')}}:{{ payMoney }} </span>{{$t('operatevip.deposit')}}{{ principal }}{{$t('operatemonth.yuan')}}+{{$t('operateday.managementFee')}}{{ fee }}{{$t('operatemonth.yuan')}}/{{$t('operatemonth.month')}}-{{$t('operateday.ticketPrice')}}{{
                      (Number(voucher_management)).toFixed(2)
                    }}{{$t('operatemonth.yuan')}}/{{$t('operatemonth.month')}}
                  </p>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="width: 100%; color: #ffffff;background-color: var(--baseColor);border-color:var(--baseColor)" @click="operateBtn">{{$t('operatevip.allocateFund')}}</el-button>
                  <p class="center">
                    {{$t('operatehuhui.balance')}}:{{ user.cash.toFixed(2) }}{{$t('operatemonth.yuan')}} &nbsp; {{$t('operateday.ticketPrice')}}:{{
                      user.voucher_management.toFixed(2)
                    }}{{$t('operatemonth.yuan')}}
                  </p>
                </el-form-item>
                <el-form-item> </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!--<div class="gppzys">
        <span>选择配资方案</span>
        <img src="../assets/img/cpic.png">
      </div>
      <div class="trader-at">
        <div class="trader-at-l">
          <p class="trader-at-tit">第一步：输入投资本金({{info.min_num}}-{{info.max_num}})</p>
          <el-input
            class="operate-input"
            v-model.number="principal"
            :placeholder="info.explain"
            id="input1"
            type="number"
            @keyup.native="principalChange"
          ></el-input>
          <p class="note">备注：{{info.explain}}</p>
          <p class="trader-at-tit">第二步：选择获得资金(选择杠杆，资金放大10倍)</p>
          <ul class="ksxz">
            <li
              v-for="(item,index) in multiple"
              :key="index"
              :class="{capital_ul2_active: cut == index}"
              @click="setCut(index,item)"
            >
              <p>
                <span class="b30">{{item[0]}}</span>倍
              </p>
              <p>月利率{{item[2]}}%</p>
              <p>{{item[3]}}元</p>
            </li>
          </ul>
        </div>
        <div class="trader-at-r">
          <p class="trader-at-tit">第三步：选择你的配资周期</p>
          <p class="mar-l-6">
            期限：自动延期&nbsp;账户管理费：
            <span class="cor-y m_span1">{{fee}}</span>元
          </p>
          <p class="note">备注：自动延期，单票持仓100%</p>
          <p class="trader-at-tit">第三步：选择开始交易时间</p>
          <p class="mar-l-6" id="p1">
            <span class="ljsx capital_ul2_active">立即生效</span>
          </p>
          <p class="trader-at-tit">第五步：确认配资信息</p>
          <table border="1" class="tab">
            <tr>
              <th>配资须知</th>
              <th>盈利100%全归您</th>
            </tr>
            <tr>
              <td>总配资资金</td>
              <td>
                <span class="cor-y allMoney">{{allMoney}}元</span>&nbsp;
                <span class="span1">{{principal}}(本金)+{{money}}(配资资金)</span>
              </td>
            </tr>
            <tr>
              <td>亏损警戒线</td>
              <td>
                <span class="cor-y span2">{{warning}}元</span>
                &nbsp;(预警线=配资资金*{{info.warning}})
              </td>
            </tr>
            <tr>
              <td>亏损平仓线</td>
              <td>
                <span class="cor-y span3">{{close}}元</span>
                &nbsp;(平仓线=配资资金*{{info.close}})
              </td>
            </tr>
          </table>
        </div>
        <div class="clear"></div>
      </div>
      <p class="tet-cen cor-y">
        备注：您需要支付的金额为：保证金
        <span class="span4">{{principal}}</span>元+
        <span class="m_span3">{{fee}}</span>元(管理费)=
        <span class="m_span2">{{payMoney}}</span>元
      </p>
      <p class="tet-cen">如果您不清楚规则，或有其他疑问，请联系客服</p>
      <p class="tet-cen p2">
        <input type="checkbox" class="check" v-model="agree">
        <span>我已阅读并同意</span>
        <router-link to="/operate/protocol">《配资合作协议》</router-link>
      </p>
      <el-button class="cp-btn" type="danger" @click="operateBtn" :disabled="disabled">我要配资</el-button>
      <div class="border"></div>
      <div class="cpxz">
        <div class="cpxz-tit">配资须知</div>
        <div v-html="tips"></div>
        &lt;!&ndash; <p>1、不得购买S、ST、*ST、S*ST、SST、以及被交易所特别处理的股票；</p>
        <p>2、不得购买权证类可以T+0交易的证券；</p>
        <p>3、不得购买或持有上市新股，次新股（或复牌股票）及不设涨跌停板限制的股票；</p>
        <p>4、可以满仓单支股票，但请保持账户内有足够的保证金，总配资资金高于预警线，以免低于平仓线，被风控部门强制平仓；</p>
        <p>5、不得进行坐庄、对敲、接盘、大宗交易、内幕信息等违反股票交易法律法规及证券公司规定的交易。</p>
        <p>6、全程无需支付账户管理费，股市有风险，投资需谨慎！市场风险莫测，务请谨慎行事！</p>
        <p>7、资金使用期限：资金免费提供，可配资15个交易日，配1-5倍 盈利70%全归您；</p>
        <p style="font-size: 18px; color: #cc0000;">第15个交易日14:30自动终止配资并结算</p>
        <p>8、风险保证金：在您配资出现亏损后用于支付亏损金，结束时如无亏损全额退还，保证金越低收益越大，同时风险也越大；</p>
        <p style="font-size: 18px; color: #cc0000;">（如何追加保证金？登陆成功后，进入“我的账户”，找到方案，点击“追加保证金”按钮）</p>
        <p>9、亏损警戒线：当总配资资金低于警戒线以下时，只能平仓不能建仓，需要尽快补充风险保证金，以免低于亏损平仓线被平仓；</p>
        <p>10、亏损平仓线：当总配资资金低于平仓线以下时，我们将有权把您的股票进行平仓，为避免平仓发生，请时刻关注风险保证金是否充足；</p>
        <p>11、开始交易时间：一般选择下个交易日，如看中行情急需交易，可直接选择今天交易。</p>
        <p>12、平仓备注：符合平仓条件且当前交易日平仓失败的，在下一个交易日9:20以集合竞价方式平仓。</p>&ndash;&gt;
      </div>-->
    </div>
    <!-- 购买成功弹窗-->
    <span class="instead"></span>
    <Operatesuccess class="operate-success" :paymoney="payMoney" :close="close" :fee="dayFee" :allmoney="allMoney"
      :principal="principal" :warning="warning" :voucher_management="voucher_management" :dateText="$t('operatemonth.month')"></Operatesuccess>
    <!--余额不足-->
    <Operatefail :principal="principal" :allmoney="allMoney" :fee="dayFee" :close="close" :warning="warning"
      :paymoney="payMoney" :balance="balance" :lack="lack" class="operate-fail"></Operatefail>
    <!-- ============================== Start change channel popup ========================== -->
    <el-dialog :visible.sync="showTradeChannelPopup" width="40%" center custom-class="tradingChannelPop">
      <div v-html="trade_rules_content_top"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreeTradeRules()"
          style="background-color: var(--baseColor);border-color:var(--baseColor) width: 200px">{{$t('operatehuhui.understand')}}
        </el-button>
        <div v-html="trade_rules_content_bottom" style="padding-top: 10px"></div>
      </span>
    </el-dialog>
    <!-- ============================== end change channel popup ========================== -->
  </div>
</template>
<script>
import $ from "jquery";
import Operatesuccess from "./module/operatesuccess";
import Operatefail from "./module/operatefail";
import CommonLoading from "./common/commonLoading";
export default {
  components: {
    Operatesuccess,
    Operatefail,
    CommonLoading
  },
  data() {
    return {
      info: {
        close: 0.3,
        delay: 20,
        explain: '',
        max_num: 2000000,
        min_num: 2000,
        min_time: 2,
        name: this.$t('operateweek.fundByDay'),
        times: 100,
        warning: 0.5,
      },
      multiple: [],
      cut: 0, //控制杠杆样式
      principal: "", //本金
      money: 0.0, //借款金额
      allMoney: 0.0, //总配资资金
      fee: 0.0, //账户管理费
      dayFee: 0.0, //按天的管理费
      warning: 0.0, //预警线
      close: 0.0, //平仓线
      payMoney: 0.0, //付款金额
      agree: true, //同意协议
      balance: 0.0, //余额
      lack: 0.0, //余额不足的差价
      disabled: false, //我要配资按钮的 防止连点
      tips: "", //配资须知
      pitchMultiple: "", //配资利率
      voucher_management: 0.0,
      user: {
        loginType: false,
        //代金券
        voucher_management: 0.0,
        //可用余额
        cash: 0.0,
        //voucher ratio
        voucher_ratio: 0.0,
      },
      trade_channel_status: "",
      showTradeChannelPopup: false,
      trade_rules_content_top: "",
      trade_rules_content_bottom: "",
      fullscreenLoading: false
    };
  },
  mounted() {
    // this.getTips();
    if (this.$store.state.loginType) {
      this.getUserinfo();
    } else {
      this.getMonthInfo();
    }
  },
  methods: {
    getUserinfo() {
      let that = this;
      that
        .$http({
          url: "/app/User/user",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.user.loginType = true;
            that.user.cash = res.data.data.cash;
            that.user.voucher_management = res.data.data.voucher_management;
            that.user.voucher_ratio = res.data.data.voucher_ratio;
            that.trade_channel_status = res.data.data.trade_channel_status;
            that.getMonthInfo();
          } else {
            that.user.loginType = false;
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //获取月配信息
    getMonthInfo() {
      let that = this;
      that
        .$http({
          url: "/app/Capital/month_info",
          method: "post",
          data: {

          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            var data = res.data.data;
            that.info = data;
            that.multiple = res.data.multiple;
            that.multiple.sort(function (a, b) {
              return b[0] - a[0];
            });
            $.each(that.multiple, function (index, item) {
              item.push((item[1] * 100).toFixed(2)); //百分比
              item.push(that.info.min_num * item[0]); //借款金额
            });
            that.principal = that.info.min_num; //本金
            that.money = that.multiple[that.cut][3]; //借款金额
            that.allMoney = that.principal + that.money; //总资金
            that.fee = (
              that.multiple[that.cut][3] * that.multiple[that.cut][1]
            ).toFixed(2); //管理费
            that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
            that.warning = that.principal * that.info.warning + that.money; //警戒线
            that.close = that.principal * that.info.close + that.money; //平仓线
            // that.payMoney = (that.principal + parseFloat(that.fee)).toFixed(2); //付款金额
            that.pitchMultiple = that.multiple[that.cut][2];
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
    //选择杠杆
    setCut(index, item) {
      let that = this;
      that.cut = index;
      that.money = item[3]; //借款金额
      that.fee = (item[3] * item[1]).toFixed(2); //管理费
      that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
      that.allMoney = that.money + that.principal; //总配资资金
      that.warning = that.principal * that.info.warning + that.money; //警戒线
      that.close = that.principal * that.info.close + that.money; //平仓线
      // that.payMoney = (that.principal + parseFloat(that.fee)).toFixed(2); //付款金额
      that.pitchMultiple = item[2]; //利率
    },
    //本金变动计算
    principalChange() {
      let that = this;
      if (that.principal == "") {
        that.zero();
      } else {
        if (that.principal >= that.info.max_num) {
          that.principal = that.info.max_num;
        } else {
          that.principal = that.principal;
        }
        $.each(that.multiple, function (index, item) {
          item[3] = parseFloat(that.principal) * item[0];
        });
        that.money = that.multiple[that.cut][3]; //借款金额
        that.fee = (
          that.multiple[that.cut][3] * that.multiple[that.cut][1]
        ).toFixed(2); //管理费
        that.dayFee = parseFloat(that.fee).toFixed(2); //按天配资的管理费
        that.allMoney = that.money + that.principal; //总操盘资金
        that.warning = that.principal * that.info.warning + that.money; //警戒线
        that.close = that.principal * that.info.close + that.money; //平仓线
        // that.payMoney = (that.principal + parseFloat(that.fee)).toFixed(2); //付款金额
      }
    },
    zero() {
      let that = this;
      $.each(that.multiple, function (index, item) {
        item[3] = "0.00";
      });
      that.money = "0.00"; //借款金额
      that.fee = "0.00"; //管理费
      that.dayFee = "0.00"; //按天配资的管理费
      that.allMoney = "0.00"; //总操盘资金
      that.warning = "0.00"; //警戒线
      that.close = "0.00"; //平仓线
      that.payMoney = "0.00"; //付款金额
    },
    //我要配资操作
    operateBtn() {
      let that = this;
      if (sessionStorage.getItem("token") == null) {
        that.$message.error(that.$t('operatevip.loginFirst'));
      } else if (that.agree == false) {
        that.$message.error(that.$t('operatevip.readAgreement'));
      } else {
        that.disabled = true;
        setTimeout(function () {
          that.disabled = false;
        }, 3000);
        //流程：请求余额  显示 余额不足弹窗 或者 确认购买弹窗
        /*if (that.user.cash > that.payMoney) {
          //余额充足

        } else {
          //余额不足
          $(".operate-fail").fadeIn(100);
        }*/
        if (that.trade_channel_status == 1) {
          that.getTradeChannel();
        } else {
          // that.fullscreenLoading = true;
          that.$refs.commonLoader.showCommonLoadigIcon();
          that
            .$http({
              url: "/app/Capital/apply_month",
              method: "post",
              data: {
                bond: that.principal,
                multiple: that.multiple[that.cut][0],
              },
            })
            .then(function (res) {
              if (res.data.status == 200) {
                if (res.data.code == 1) {
                  $(".operate-success").fadeIn(100);
                } else if (res.data.code == 2) {
                  that.getTradeChannel();
                } else if (res.data.code == 0 || res.data.code == -1) {
                  that.$message.error(that.$t(res.data.msgId));
                }
              } else {
                that.$message.error(that.$t(res.data.msgId));
              }

            }).finally(() => {
              // that.fullscreenLoading = false;
              that.$refs.commonLoader.hideCommonLoadigIcon();
            });
        }
        /* that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token")
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              that.balance = parseFloat(res.data.data.cash);
              if (that.balance > that.payMoney) {
                //余额充足
                that
                  .$http({
                    url: "/",
                    method: "post",
                    data: {
                      nozzle: "apply_month",
                      token: sessionStorage.getItem("token"),
                      bond: that.principal,
                      multiple: that.multiple[that.cut][0]
                    }
                  })
                  .then(function(res) {
                    if (res.data.code == 1) {
                      $(".operate-success").fadeIn(100);
                    } else if (res.data.code == 0 || res.data.code == -1) {
                      that.$message.error(that.$t(res.data.msgId));
                    }
                  });
              } else {
                //余额不足
                that.lack = that.payMoney - that.balance;
                $(".operate-fail").fadeIn(100);
              }
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(that.$t(res.data.msgId));
            }
          });*/
      }
    },
    // ============= get the content of trade channel popup agreement ===========
    getTradeChannel() {
      let that = this;
      that
        .$http({
          url: "/app/User/trade_popup",
          method: "post",
          data: {
            
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.trade_rules_content_top = res.data.data.content_top;
            that.trade_rules_content_bottom = res.data.data.content_bottom;
            that.showTradeChannelPopup = true;
          } else {
          }
        });
    },

    // ============================== Click agree the trade rules ========================
    agreeTradeRules() {
      let that = this;
      that
        .$http({
          url: "/app/TradeChannalLog/modify_trade_status",
          method: "post",
          data: {
            trade_channel_status: 1,
          },
        })
        .then(function (res) {
          if (res.data.status == 200) {
            that.$message({
              message: that.$t(res.data.msgId),
              type: "success",
              duration: 1000,
            });
            that.showTradeChannelPopup = false;
            that.trade_channel_status = 0;
          } else {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },

    isMultiple() {
      let that = this;
      let principal = parseInt(that.principal);
      if (
        isNaN(principal) ||
        principal === "" ||
        principal < Number(that.info.min_num) ||
        principal > Number(that.info.max_num)
      ) {
        that.principal = 0;
        that.zero();
      } else {
        principal = parseInt(principal / 100) * 100;
        that.principal = principal;
      }
      that.principalChange();
    },
    //配资须知
    getTips() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "operate_notice",
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.tips = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$message.error(that.$t(res.data.msgId));
          }
        });
    },
  },
  watch: {
    fee: function (value) {
      let that = this;
      if (that.user.loginType) {
        //管理费*0.5>本身代金券?支付代金券=本身代金券 : 支付代金券=管理费*0.5
        Number(value) * that.user.voucher_ratio >
          Number(that.user.voucher_management)
          ? (that.voucher_management = Number(that.user.voucher_management))
          : (that.voucher_management = Number(value) * that.user.voucher_ratio);
      }
      that.payMoney = (
        that.principal +
        parseFloat(value) -
        Number(that.voucher_management)
      ).toFixed(2); //付款金额
    },
  },
};
</script>
<style scoped>
@import url("./../assets/css/operate.css");

.operate-input {
  margin-left: 6%;
  width: 70%;
  height: 40px;
}

.operate-success,
.operate-fail {
  display: none;
}

.assist_title {
  font-weight: bold;
  font-size: 20px;
}

.multiple {
  border-radius: 4px;
  padding: 15px 0;
  border: 1px solid var(--baseColor);
}

.multiple p {
  text-align: center;
  line-height: 1.6;
  font-size: 18px;
  color: var(--baseColor);
}

.multiple_detail {
  /*padding-top: 10px;*/
}

.capital_ul2_active p {
  color: #ffffff !important;
}

.money_info {
  border-radius: 4px;
}

.money_info p {
  font-size: 16px;
}

.info_title {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  font-weight: bold;
  font-size: 16px;
}

.multiple_box {
  width: 19%;
  float: left;
  margin-right: 1.25%;
}

.multiple_box:last-child {
  margin-right: 0;
}

.infoColor {
  color: #909399;
}

.capital_ul2_active {
  background: var(--baseColor);
  color: #fff !important;
  border: 1px solid var(--baseColor) !important;
}
</style>
<style>
.tradingChannelPop .el-dialog__body {
  padding: 0px 20px;
}

/* .tradingChannelPop .el-dialog__header {
  display: none;
} */
</style>





// WEBPACK FOOTER //
// src/components/operatemonth.vue